import { DeepReadonly, IImportData } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const defaultImportData: DeepReadonly<IImportData> = deepFreeze({
  studentNo: '',
  email: '',
  familyName: '',
  givenName: '',
  offers: [],
});
